var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"exclude":"Detail,SearchRes,shippingScheduleSearch,shippingSchedule,CompanyRegister,LoginChosenStatus"}},[_c('router-view',{ref:"routeView",on:{"clearCache":_vm.clearCache}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }